import { RequestAttributes } from '~shared/types'
import { Attachment } from '~shared/types'

import { axiosInstance } from '.'

const requestAPI = '/api/v1/requests'

export const createRequest = async (
  requestType: string,
  attributes: RequestAttributes,
  files: Attachment[],
) => {
  return await axiosInstance.post(
    requestAPI,
    { requestType, attributes, files },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )
}

export const updateRequest = async (
  id: string,
  requestType: string,
  attributes: RequestAttributes,
  files: Attachment[],
) => {
  return await axiosInstance.put(
    `${requestAPI}/${id}`,
    { requestType, attributes, files },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )
}

export const reviewRequest = async (
  id: string,
  isApproved: boolean,
  comment?: string,
) => {
  return await axiosInstance.post(
    `${requestAPI}/${id}/review`,
    {
      isApproved,
      comment,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )
}

export const uploadDocs = async (id: string, fileWithKeys: Attachment[]) => {
  return await axiosInstance.post(`${requestAPI}/${id}/attachments`, {
    files: fileWithKeys,
  })
}

export const getRequests = async () => {
  return await axiosInstance.get(requestAPI)
}

export const getRequest = async (id: string) => {
  return await axiosInstance.get(`${requestAPI}/${id}`)
}

export const deleteRequest = async (id: string) => {
  return await axiosInstance.delete(`${requestAPI}/${id}`)
}

export const getUserPermissionsForRequest = async (id: string) => {
  return await axiosInstance.get(`${requestAPI}/${id}/user-permissions`)
}

export const getRequestLifecycle = async (id: string) => {
  return await axiosInstance.get(`${requestAPI}/${id}/lifecycle`)
}

export const getRequestActivityLogs = async (id: string) => {
  return await axiosInstance.get(`${requestAPI}/${id}/activity-logs`)
}

export const getCurrentRequestStage = async (id: string) => {
  return await axiosInstance.get(`${requestAPI}/${id}/current-stage`)
}

export const sendToReview = async (id: string, reviewer?: string) => {
  return await axiosInstance.post(`${requestAPI}/${id}/send-to-review`, {
    reviewer,
  })
}

export const sendToEvaluation = async (
  id: string,
  hasPotentialCoi?: boolean,
  coiDeclaration?: string,
  reviewerId?: string,
) => {
  return await axiosInstance.post(`${requestAPI}/${id}/send-to-review`, {
    hasPotentialCoi,
    coiDeclaration,
    reviewer: reviewerId,
  })
}

export const submitReviewClearance = async (id: string) => {
  return await axiosInstance.post(`${requestAPI}/${id}/submit-review-clearance`)
}

export const getAttachmentsByStages = async (requestId: string) => {
  return await axiosInstance.get(`${requestAPI}/${requestId}/attachments`)
}

export const getDepartments = async () => {
  return await axiosInstance.get(`${requestAPI}/departments`)
}

export const getRequestTypes = async () => {
  return await axiosInstance.get(`${requestAPI}/request-types`)
}
